import { render, staticRenderFns } from "./dictItemDialog.vue?vue&type=template&id=250517ba&scoped=true"
import script from "./dictItemDialog.vue?vue&type=script&lang=js"
export * from "./dictItemDialog.vue?vue&type=script&lang=js"
import style0 from "./dictItemDialog.vue?vue&type=style&index=0&id=250517ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250517ba",
  null
  
)

export default component.exports